<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
    }
  }
}
</script>

<style>
  .el-header, .el-footer {
    background-color: #418ae9;
    color: #fff;
    line-height: 60px;
    padding: 0 0 0 20px;
  }
</style>
